<template>
  <svg
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11 22.8333L12.1667 24L16 20.1667L19.8333 24L21 22.8333L16 17.8333L11 22.8333ZM9.5 15.4583L11.0167 16.975L16 11.9917L20.9833 16.975L22.5 15.4583L16 8.95833L9.5 15.4583Z"
      fill="currentColor"/>
  </svg>
</template>
